import { Component, Injector, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatFormFieldControl, MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS, MatDatepicker } from '@angular/material';
import { AbstractMatFormFieldControl } from '@mctic/ng-core';
import * as moment from 'moment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Moment, isMoment } from 'moment';
import { FormControl, Validators } from '@angular/forms';

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-datepicker-year',
  styleUrls: ['./datepicker-year.component.scss'],
  providers: [
    {provide: MatFormFieldControl, useExisting: DatePickerYear},
    { provide: MAT_DATE_LOCALE, useValue: 'pt' },
    { provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: MY_FORMATS
    }
  ],
  template: `
  <mat-form-field appearance="outline" fxFlex.gt-xs="tamanhoCampo" fxFlexFill>
    <mat-label>{{label}}</mat-label>
    <input  [matDatepicker]="datePicker" matInput [min]="dataMinima" [formControl]="control" maxLength="4"/>
    <mat-datepicker-toggle [for]="datePicker" matSuffix></mat-datepicker-toggle>
    <mat-datepicker #datePicker (yearSelected)="chosenYearHandler($event, datePicker)"
                    panelClass="year-picker" startView="multi-year">
    </mat-datepicker>
    <mat-error mctic-validation controlName="anoBaseCtrl"></mat-error>
  </mat-form-field>
  `
})
export class DatePickerYear extends AbstractMatFormFieldControl<Date> implements OnInit{

  @Input() min: number = 0;
  @Input() readonly = false;
  @Input() label: string = '';
  @Input() tamanhoCampo:string = '25';
  @Output() alteracaoData = new EventEmitter<any>();

  control: FormControl = new FormControl();;
  dataMinima = moment('01-01-1990', 'MM-DD-YYYY');

  constructor(injector: Injector) {
    super(injector);
    this.control.setValidators(Validators.required);
  }

  ngOnInit() {
    this.control = this.formControl;
    this.dataMinima.year(this.min);
    this.control.valueChanges.subscribe((value) => {
      if(value != undefined && value != null) {
        if(value._i && value._i.length >= 4){
          this.alteracaoData.emit();
        }
      }
    })
  }

  chosenYearHandler(normalizedYear: Moment, datepicker: MatDatepicker<Moment>) {
    this.control.patchValue(moment());
    const ctrlValue = this.control.value;
    ctrlValue.year(normalizedYear.year());
    this.control.patchValue(ctrlValue);
    datepicker.close();
    this.alteracaoData.emit();
  }
}
